import React, { useState, useEffect, useRef } from "react"
import Checkbox from "@material-ui/core/Checkbox"
import NoSsr from '@material-ui/core/NoSsr';


const ConsentForm = ({ onConsentChanged, legalText }) => {
  const legalBlurbContent = legalText || `By clicking “Save” and transmitting the User Submission (as defined in the Terms of Use) to Dailybreak, you hereby grant to Dailybreak a perpetual, worldwide, non-exclusive, royalty-free, fully paid up, sublicenseable and transferable license to use, post and store such content without restriction.`
  const ww = e => {

      onConsentChanged(e.target.checked)

  }
  return (
    <div className="consent-form-container">
        <NoSsr>
            <Checkbox name="consent" type="checkbox"  onChange={ww} />
        </NoSsr>
      <p>{legalBlurbContent}</p>
    </div>
  )
}

export default ConsentForm
